export default function createProductLink(type, id, applyUrl) {
  const path = `/product/${type.toLowerCase()}/${id}/`
  return applyUrl
    ? `https://${process.env.REACT_APP_FRONTEND_HOST}${path}`
    : path
}
